import React from 'react'
function Bulksmservice() {
  return (
    <>
       <section className="bg-gradient-to-br from-[#e710ea] to-black py-10 md:py-32">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <h1 className="text-white font-bold font-serif text-4xl md:text-65l leading-tight mb-6 ">
             Bulk SMS Service's
          </h1>
          <p className="text-white text-lg md:text-2xl font-serif ">
            Experience the fastest and most reliable Bulk SMS Service. Reach thousands of people with a single click. Ideal for campaigns, promotions, and business communication.
          </p>
        </div>
      </section>

      <section className="bg-white py-12">
  <div className="container mx-auto px-4">
    {/* Services and Benefits Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {/* Our Services Section */}
      <div>
        <h2 className="text-3xl font-bold mb-6">Our Services</h2>
        <ul className="space-y-4">
          {[
            "Bulk SMS for Promotions and Campaigns",
            "Transactional SMS for Instant Alerts",
            "Voice SMS & Picture SMS Services",
            "Shortcode and Longcode SMS Solutions",
            "WhatsApp API for Seamless Messaging",
            "Web-Based SMS Platform with Real-Time Reports",
          ].map((service, index) => (
            <li key={index} className="flex items-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="mr-3 w-6 text-[#e710ea]"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
                />
              </svg>
              <p className="text-base text-slate-700">{service}</p>
            </li>
          ))}
        </ul>
      </div>

      {/* Why Choose Us Section */}
      <div>
        <h2 className="text-2xl font-bold mb-6">Why Choose Us?</h2>
        <ul className="space-y-4">
          {[
            "Instant SMS Delivery with Multiple Gateways",
            "Competitive Pricing for Various Packages",
            "Support for Regional and Unicode SMS",
            "Extensive Coverage Across India",
          ].map((benefit, index) => (
            <li key={index} className="flex items-start">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="mr-3 w-6 text-[#e710ea]"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z"
                />
              </svg>
              <p className="text-base text-slate-700">{benefit}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
</section>

      
    </>
  )
}

export default Bulksmservice